;(function( window, document, $, undefined ) {
	'use strict';

	// Intro

	function banner() {

    // Banner Mosaic
    function backgroundImages( $el ) {
      $el.each(function(){
        var $this = $(this);
        var $image = $this.find('img');
        var imgSrc = $image.attr('src');
        $this.css('background-image', 'url("' + imgSrc + '")');
        $image.hide();
      });
    }

		// Globals
		return {
      backgroundImages: backgroundImages
		};

	}

	// Globals
	window.app = window.app || {};
  window.app.banner = banner();

})( window, document, jQuery );
